export const THEME_OPTIONS = {
  palette: {
    branded: {
      main: "#ffd52b",
    },
    secondary: {
      main: "#414141",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        contained: {
          boxShadow: "none",
          "&:active": {
            boxShadow: "none",
          },
          "&:hover": {
            boxShadow: "none",
          },
          "&:focus": {
            boxShadow: "none",
          },
        },
        outlinedPrimary: {
          "&:hover": {
            color: "#1976d2",
          },
          "&:focus": {
            color: "#1976d2",
          },
        },
        containedPrimary: {
          "&:hover": {
            color: "#fff",
          },
          "&:focus": {
            color: "#fff",
          },
        },
        containedBranded: {
          backgroundColor: "#ffd52b",
          color: "#303030",
          "&:hover": {
            backgroundColor: "#f3c81b",
            color: "#303030",
          },
          "&:focus": {
            color: "#303030",
          },
        },
        outlinedBranded: {
          color: "#303030",
        },
      },
    },
  },
}
